import { Container, Stack, styled } from '@ethings/ui-toolkit';
import Box from '@mui/material/Box';
import { ComponentProps, FC } from 'react';
import { FlexBox } from '../flex-box';
import { InternalProps } from './types';

const Row = styled((props: ComponentProps<typeof Stack>) => (
  <Stack direction="row" spacing={2} {...props} />
))({
  alignItems: 'center',
});

export const Layout: FC<InternalProps> = ({ listContent, paginationComponent, search }) => (
  <FlexBox className="ListPage-root" sx={{ overflowY: 'auto' }}>
    <Container>
      <Stack direction="column" spacing={1} py={1}>
        <Row lineHeight="2rem">
          {search}
        </Row>
        <Stack spacing={2} py={1}>
          <Box>
            {listContent}
          </Box>
          {paginationComponent
            ? <Box display="flex" sx={{ justifyContent: 'center' }}>
              {paginationComponent}
            </Box>
            : null}
        </Stack>
      </Stack>
    </Container>
  </FlexBox>
);
